// extracted by mini-css-extract-plugin
export var dropdown = "ProfileDropdown-module--dropdown--72110";
export var profileContainer = "ProfileDropdown-module--profileContainer--61ff3";
export var userAvatar = "ProfileDropdown-module--userAvatar--5b835";